import React from 'react';
import styled from '@emotion/styled';
import { H2, Text } from 'ds/components/typography';
import { TitleWrapper } from './styled';

interface TitleProps {
  title: string;
  subtitle: string;
}

const TitleText = styled(H2)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-size: 17px !important;
  line-height: 22px !important;
`;

export const Title: React.FC<TitleProps> = ({ title, subtitle }) => {
  return (
    <TitleWrapper>
      <TitleText weight="bold">{title}</TitleText>
      <Text>{subtitle}</Text>
    </TitleWrapper>
  );
};
